import React, { Fragment } from 'react'
import moment from '../utils/momentTimeZone'
import tachyon from '../utils/tachyon'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import AriaTooltips from './AriaTooltips';

const InstanceBookingButton = (instance, event) => {
    if (instance.showBookingButton) {
        if (instance.soldOut) {
            return (
                <Fragment>
                    <span class="c-btn c-btn--disabled c-btn--ghost c-btn--small">
                        <Time datetime={instance.datetime} eventType={event.attendable.eventType} calendarBookingLabel={event.attendable.calendarBookingLabel || ''} /> 
                        <span class="c-time-slot__sold-out-label">Sold out</span>
                    </span>
                </Fragment>
            )
        }

        return (
            <Fragment>
                {instance.limitedAvailability
                    ? <span class="c-time-slot__limited-label c-small-label">Limited Tickets</span> 
                    : ''}
                <a href={instance.booking_url} className="c-btn c-btn--red c-btn--ghost c-btn--small">
                    <Time datetime={instance.datetime} eventType={event.attendable.eventType} calendarBookingLabel={event.attendable.calendarBookingLabel || ''} /> 
                    <i className="far fa-angle-right"></i>
                </a>
            </Fragment>
        )
    }
    return (
        <Fragment>
            <span className="c-btn c-btn--disabled c-btn--ghost c-btn--small">Coming soon <i className="far fa-angle-right"></i></span>
        </Fragment>
    )
}



const Time = ({datetime, eventType, calendarBookingLabel}) => {

    const mTime = moment.unix(datetime)
    const formattedTime = mTime.format('h.mm A')

    if (calendarBookingLabel) {
        return (
            <Fragment>
                {calendarBookingLabel}
            </Fragment>
        )
    }

    // Special case for online performances
    if (eventType.includes('Online performances')) {
        return (
            <Fragment>
                Watch
            </Fragment>
        )
    }

    if (formattedTime === '12.00 AM') {
        return (
            <Fragment>
                {mTime.format('h.mm')} <span>Midnight</span>
            </Fragment>
        )
    }

    if (formattedTime === '12.00 PM') {
        return (
            <Fragment>
                {mTime.format('h.mm')} <span>Noon</span>
            </Fragment>
        )
    }

    return (
        <Fragment>
            {mTime.format('h.mm')} <span>{mTime.format('A')}</span>
        </Fragment>
    )

}

const EventCalendarListing = ({hit}) => (
    <div className="c-day-block fadeIn">
        <div className="c-day-block__inner o-max o-max--1200">
            {hit.events ?
                <div className="c-day-events">
                    <div className="c-day-block__date-holder">
                        <h4 className="c-day-block__date">
                            {moment.unix(hit.unixDay).format('dddd D')}
                            <span className="c-day-block__date--month">{moment.unix(hit.unixDay).format('MMMM')}</span>
                        </h4>
                    </div>
                    {hit.events.map(event => (
                        <div key={event.post_id} className="c-day-event">
                            <a className="c-day-event__link" href={event.permalink}>
                                <figure className="fig c-day-event__img">
                                    <LazyLoadImage alt={event.post_title} src={tachyon.fetch(event.cover_url, {resize: '240,110', gravity: 'center'})} height={55} width={120}
                                        placeholderSrc={tachyon.fetch(event.cover_url, {resize: '24,11', gravity: 'center'})} />
                                </figure>
                            </a>
                            <div className="c-day-event__body">
                                <div className="c-day-event__details">
                                    <a className="c-day-event__link" href={event.permalink}>
                                        <h5 className="c-day-event__title">{event.post_title}</h5>
                                    </a>
                                    <span className="c-day-event__meta c-day-event__type" dangerouslySetInnerHTML={{ __html: event.attendable.eventType }}></span>
                                    <div className="c-event-card__meta c-event-card__venue">
                                        {event.instances.reduce((venues, instance) => {
                                            if(instance.venue && venues.indexOf(instance.venue) === -1) {
                                                venues.push(instance.venue)
                                            }
                                            return venues
                                        }, []).map(venue => <span key={venue}><i className="fal fa-map-marker-alt"></i>&nbsp;{venue}</span>)}
                                    </div>
                                </div>
                                <div className="c-day-event__timeslots">
                                    {event.instances.map((instance, idx) => (
                                        <div key={`${idx}:${instance.datetime}`} className="c-time-slot">
                                            <div className="c-time-slot__details">
                                                <AriaTooltips access={instance.access || []} />
                                                { instance.note && instance.note !== ''  &&
                                                <span className="c-time-slot__notes" dangerouslySetInnerHTML={{ __html: instance.note }} />
                                                }
                                            </div>
                                            <div>{InstanceBookingButton(instance, event)}</div>
                                            {!instance.soldOut 
                                                ? <span className="c-event-card__meta c-event-card__price-label">{instance.priceLabel}</span> 
                                                : ''}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                : undefined}
        </div>
    </div>
);


export default EventCalendarListing;



// WEBPACK FOOTER //
// ./src/whatson/components/EventCalendarListing.js